import { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
// アイコンを丸形の ExclamationCircleFill に変更
import { ExclamationCircleFill } from "react-bootstrap-icons";
import { useTohonBuy } from "../../context/TohonBuyContext";
import { TOHON_PENDING_STORAGE_KEY } from "../../utils/Util";

const PaymentCancelOverlay = () => {
  const [show, setShow] = useState(false);
  // 'subscription'（サブスク）| 'tohon'（謄本購入）
  const [mode, setMode] = useState(null);
  const { restoreTohon } = useTohonBuy();

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const tohonResult = query.get("tohon_result");

    if (tohonResult === "cancel") {
      // 謄本購入：決済キャンセル
      setMode("tohon");
      setShow(true);

      // 再決済できるよう、遷移前に保存した購入リストを復元する（リストは維持）
      try {
        const saved = sessionStorage.getItem(TOHON_PENDING_STORAGE_KEY);
        if (saved) {
          restoreTohon(JSON.parse(saved));
        }
      } catch (e) {
        console.warn("購入リストの復元に失敗しました", e);
      }

      // クエリのみ削除し、地図位置（hash）は残す
      window.history.replaceState(
        {},
        document.title,
        window.location.pathname + window.location.hash
      );
    } else if (query.get("cancel") === "true") {
      // サブスクリプション：決済キャンセル（既存処理）
      setMode("subscription");
      setShow(true);
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, [restoreTohon]);

  const handleClose = () => setShow(false);

  if (!show) return null;

  return (
    <Modal show={show} onHide={handleClose} centered size="md">
      <Modal.Body className="text-center p-5">
        {/* 色を #ffc107 (BootstrapのWarning色) や #6c757d (グレー) に変更 */}
        <ExclamationCircleFill size={70} color="#ffc107" className="mb-4" />

        <h3 className="fw-bold mb-3" style={{ color: "#495057" }}>
          お支払いが完了しませんでした
        </h3>

        {mode === "tohon" ? (
          <p className="text-muted mb-4" style={{ lineHeight: "1.8" }}>
            決済手続きが中断されたか、
            <br />
            カードの承認が得られなかった可能性があります。
            <br />
            ご注文内容は保持していますので、
            <br />
            もう一度お手続きをやり直すことができます。
          </p>
        ) : (
          <p className="text-muted mb-4" style={{ lineHeight: "1.8" }}>
            決済手続きが中断されたか、
            <br />
            カードの承認が得られなかった可能性があります。
            <br />
            大変お手数ですが、もう一度お手続きをやり直すか、
            <br />
            別のカードのご利用をご検討ください。
          </p>
        )}

        <div className="d-grid gap-2">
          {/* ボタンを danger から secondary (グレー) または outline に変更 */}
          <Button
            variant="secondary"
            size="lg"
            onClick={handleClose}
            className="fw-bold"
          >
            閉じる
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PaymentCancelOverlay;
